export function getPath(dirname, filename) {
  if (dirname === '') {
    return filename;
  }
  return `${dirname}/${filename}`;
}
